export default {
  namespaced: true,
  getters: {
    language: () => localStorage.getItem('language'),
  }
}
